import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ContactTracingService } from '../services/contact-tracing.service';
import { RoutingService } from '@shared/services/routing.service';
import { UserService } from '@shared/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class ContactTracingGuard implements CanActivate  {

  constructor(private contactTracingService: ContactTracingService,
              private userService: UserService,
              private routingService: RoutingService,
              private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    console.log(`ContactTracingGuard`);

    if (this.contactTracingService.isContactTracing) {
      return true;
    } else {
      this.routingService.redirectToLco();
      return false;
    }
  }
}
